module.exports = __webpack_public_path__ + "static/media/logoIcon.9a5e67b0.png";